import roles from '../utils/roles.js';

async function adminHelper(Vue, options) {
  if (options.router) {
    const router = options.router;

    await router.beforeEach((to, from, next) => {
      if (!to.meta.middleware || !to.meta.middleware.includes('admin')) {
        return next();
      }
      if (options.store.getters.isLogged && options.store.getters.user.role === roles.Admin) {
        return next();
      } else {
        return next({ name: 'home' });
      }
    });
  }
}

export default adminHelper;
